import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// // 🛡️ Intercetta errori globali JS
// window.onerror = function (message, source, lineno, colno, error) {
//   alert(
//     'Errore applicazione:\n' +
//       'Messaggio: ' +
//       message +
//       '\n' +
//       'Sorgente: ' +
//       source +
//       '\n' +
//       'Linea: ' +
//       lineno +
//       '\n' +
//       'Colonna: ' +
//       colno +
//       '\n' +
//       'Errore: ' +
//       (error ? error.stack : 'n/a'),
//   );
//   return false; // lascia propagare l’errore
// };

// // 🛡️ Intercetta promesse non gestite
// window.addEventListener('unhandledrejection', function (event) {
//   alert(
//     'Errore Promise non gestita:\n' +
//       'Motivo: ' +
//       (event.reason?.message || event.reason || 'n/a'),
//   );
// });

// 🔁 Bootstrap dell'applicazione
bootstrapApplication(AppComponent, appConfig).catch((err) => {
  // alert('Errore durante il bootstrap: ' + (err?.message || err));
  console.error(err);
});
